import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { brand } from "@/content/site";

// Breadcrumbs for deeper pages + BreadcrumbList structured data.
export default function Breadcrumbs({ items }) {
  // items: [{ label, to }]  (last item = current page, no link needed)
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: `${brand.siteUrl}${it.to}`,
    })),
  };

  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="flex items-center flex-wrap gap-1.5 text-sm text-mid-neutral"
    >
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.to} className="flex items-center gap-1.5">
            {last ? (
              <span className="font-semibold text-forest">{it.label}</span>
            ) : (
              <Link to={it.to} className="hover:text-forest transition-colors">
                {it.label}
              </Link>
            )}
            {!last && <ChevronRight className="h-3.5 w-3.5 text-border-neutral" />}
          </span>
        );
      })}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </nav>
  );
}
